// Where a reader arrived from (OF.Layouts.Site). The server worked the
// source out; the browser makes it count once a tab, however many pages the
// reader then opens or reloads, and takes the link's utm_* parameters out of
// the address bar so a link copied from it does not pass our tags on.

const KEY = "of:arrived";

function firstInTab() {
  try {
    if (sessionStorage.getItem(KEY)) return false;
    sessionStorage.setItem(KEY, "1");
    return true;
  } catch (_error) {
    // No storage (a locked-down browser): count, at worst once a page load.
    return true;
  }
}

function dropTags() {
  const url = new URL(location.href);
  const tags = [...url.searchParams.keys()].filter((key) => key.startsWith("utm_"));
  if (tags.length === 0) return;

  tags.forEach((key) => url.searchParams.delete(key));
  history.replaceState(history.state, "", url.pathname + url.search + url.hash);
}

export function arrive(source) {
  dropTags();
  if (firstInTab()) {
    globalThis.Hologram.dispatchAction("count_arrival", "layout", {source});
  }
}
